import React, { Fragment, useState } from "react"
import {
  Container,
  Button,
  Stepper,
  Step,
  StepLabel,
  Box
} from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import styles from "./styles"
import clsx from "clsx"
import SwipeableViews from "react-swipeable-views"
import SplitBottomNav from "components/SplitBottomNav"
import OnBoardingContent from "./components/OnBoardingContent"
import { useHistory } from "react-router-dom"
import capture from "../../assets/capture.jpg"
import media from "../../assets/media.jpg"
import social from "../../assets/social-2.svg"

function getSteps() {
  return [
    {
      image: capture,
      heading: "Share Your Moments",
      content:
        "Share photos and videos with your organization to help them create authentic social media content. Whether the moment is big, or small, share anything you think is interesting!"
    },
    {
      image: media,
      heading: "Media Moderated",
      content:
        "Once you submit a post to your organization, the moderator will choose what to post across the organizations social media channels -- no extra work for you, just snap and send!"
    },
    {
      image: social,
      heading: "Social Media Posts",
      content:
        "Sit back, relax and watch your content come to life. Don't worry, you will get credit if the moderator chooses your post -- plus office bagging rights!"
    }
  ]
}

const OnBoarding = ({ classes }) => {
  const history = useHistory()
  const [currentStep, setCurrentStep] = useState(0)
  const steps = getSteps()

  const handleSkip = () => {
    history.push("/app/feed")
  }
  const handleBack = () => {
    setCurrentStep(currentStep - 1)
  }

  const handleNext = () => {
    if (currentStep !== steps.length - 1) {
      setCurrentStep(currentStep + 1)
    } else {
      history.push("/app/feed")
    }
  }

  const handleChange = index => {
    setCurrentStep(index)
  }

  const handleClick = index => {
    setCurrentStep(index)
  }

  return (
    <Fragment>
      <Container className={classes.container}>
        <SwipeableViews
          className={classes.contentContainer}
          index={currentStep}
          onChangeIndex={handleChange}
        >
          {steps.map((step, index) => {
            return <OnBoardingContent {...step} key={index} />
          })}
        </SwipeableViews>
        <Box display="flex" justifyContent="center">
          <Stepper
            activeStep={currentStep}
            alternativeLabel
            className={classes.stepContainer}
          >
            {steps.map((label, index) => {
              const isActive = index === currentStep
              return (
                <Step key={label}>
                  <StepLabel
                    icon={
                      <div className={classes.root}>
                        <div
                          className={clsx(classes.circle, {
                            [classes.active]: isActive
                          })}
                          onClick={() => handleClick(index)}
                        />
                      </div>
                    }
                  />
                </Step>
              )
            })}
          </Stepper>
        </Box>
        {window.innerWidth >= 1280 ? (
          <Box style={{ width: "500px", margin: "0 auto" }}>
            <Button
              className={classes.backButton}
              variant="contained"
              color="primary"
              onClick={currentStep === 0 ? handleSkip : handleBack}
            >
              {currentStep === 0 ? "Skip" : "Back"}
            </Button>
            <Button
              variant="contained"
              color="primary"
              className={classes.nextButton}
              onClick={handleNext}
            >
              {currentStep < steps.length - 1 ? "Next" : "Got It >"}
            </Button>
          </Box>
        ) : null}
      </Container>

      {window.innerWidth < 1280 ? (
        <SplitBottomNav>
          <Button
            color="primary"
            onClick={currentStep === 0 ? handleSkip : handleBack}
          >
            {currentStep === 0 ? "Skip" : "Back"}
          </Button>
          <Button onClick={handleNext}>
            {currentStep < steps.length - 1 ? "Next" : "Got It >"}
          </Button>
        </SplitBottomNav>
      ) : null}
    </Fragment>
  )
}

export default withStyles(styles)(OnBoarding)



// WEBPACK FOOTER //
// ./src/pages/OnBoarding/index.js